import { IQaState, IConditionAnswer } from './types';
import { getArrayFromObject } from '../../helpers'

// export const getQa = (state: IValuationState) => state.qa.;
export const getQaColour = (state: IQaState) => state.qa.colour || '';
export const getQaInterestedNext = (state: IQaState) => state.qa.interestedNext || '';
export const getQaConditions = (state: IQaState) => state.qa.conditions;
export const getQaConditionsArray = (state: IQaState) => getArrayFromObject(state.qa.conditions, 'number', 'value');
export const getQaAnswers = (state: IQaState) => state.qa.answers;
export const getQaAnswersArray = (state: IQaState) => {
    const r: any = [];
    state.qa.answers.forEach(o => {
        r.push({
            Question: o.Question,
            Value: parseInt(o.Value)
        })
    });
    return r;
};